import Skeleton from "react-loading-skeleton";

import { cn } from "@virtual-brain-lib/frontend-design-system/utils";

interface MessageAssistantLoadingProps {
	readonly className?: string;
}

export default function MessageAssistantLoading({ className }: MessageAssistantLoadingProps) {
	return (
		<div className={cn("w-full", className)}>
			<Skeleton
				className="animate-fade-in-opacity opacity-0 [animation-delay:0.75s]"
				count={3}
			/>
			<Skeleton
				className="w-3/4 animate-fade-in-opacity opacity-0 [animation-delay:1.5s]"
				count={1}
			/>
			<Skeleton
				className="animate-fade-in-opacity opacity-0 [animation-delay:2.25s]"
				count={1}
			/>
		</div>
	);
}
